/* クイック購入の候補表示順。Book1(2).xlsx の順位を10倍して出力。 */
window.quickPurchaseOrder = {
  'h300sbl': 10,
  'h300sivo': 20,
  'h300sgg': 30,
  'h450sbl': 50,
  'h450sivo': 60,
  'h450sgg': 70,
  'h600sbl': 90,
  'h600sivo': 100,
  'h600sgg': 110,
  'h900sbl': 130,
  'h900sivo': 140,
  'h900sgg': 150,
  'h1200sbl': 160,
  'h1200sivo': 170,
  'h1200sgg': 180,
  'h1500sbl': 190,
  'h1500sivo': 200,
  'h1500sgg': 210,
  'h2000sbl': 220,
  'h2000sivo': 230,
  'h2000sgg': 240,
  'h2500sbl': 270,
  'h2500sivo': 280,
  'h2500sgg': 290,
  'h3000sbl': 300,
  'h3000sivo': 310,
  'h3000sgg': 320,
  'h4000sbl': 330,
  'h4000sivo': 340,
  'h4000sgg': 350,
  'h4000gr': 390,
  'h4000b1': 410,
  'h4000wgr': 440,
  'h4000y1': 460,
  'h4000ccb': 500,
  'h4000mca': 510,
  'hma300smcc': 570,
  'hma450smcc': 580,
  'hma600smcc': 590,
  'hma900smcc': 600,
  'hma1200smcc': 610,
  'hma1500smcc': 620,
  'hps300spsl': 640,
  'hps450spsl': 650,
  'hps600spsl': 660,
  'hps900spsl': 670,
  'hps1200spsl': 680,
  'hps1500spsl': 690,
  'hps2000spsl': 700,
  'hps2500spsl': 720,
  'hps3000spsl': 730,
  'hps4000spsl': 740,
  'hga4000epeebl': 920,
  'hga4000absegr': 930,
  'hc4000bl': 970,
  'hpea4000ivo': 1160,
  'hpea4000wgr': 1170,
  'hpeb4000ivo': 1180,
  'hpec4000ivo': 1200,
  'hpec4000wgr': 1220,
  'hh4000cgr': 1640,
  'hh4000b1': 1650,
  'hh4000g1': 1660,
  'hh4000p1': 1670,
  'hh4000y1': 1680,
  's454000cgr': 1760,
  's454000b1': 1770,
  's454000g1': 1780,
  's454000p1': 1790,
  's454000y1': 1800,
  'hb4000ivo': 2140,
  'hb4000gr': 2150,
  'hb4000ccb': 2170,
  'hb4000mca': 2180,
  'hb34000gr': 2300,
  'hbt600sdbr': 2310,
  'hbt900sdbr': 2320,
  'hbt1800sdbr': 2330,
  'hl41800sbl': 2390,
  'hl42700sbl': 2400,
  'hl44000bl': 2410,
  'hl44000ivo': 2420,
  'hlps4000psl': 2480,
  'hmp1435r150sbl': 4050,
  'hmp1435r150sivo': 4060,
  'hmp1435r150sgg': 4070,
  'hmp2184r600sbl': 4080,
  'hmp2184r600sivo': 4090,
  'hmp2184r600sgg': 4100,
  'j1sbl': 4800,
  'j1gr': 4810,
  'j2sbl': 4820,
  'j2gr': 4830,
  'j3sbl': 4840,
  'j3gr': 4850,
  'j4sbl': 4860,
  'j4sivo': 4870,
  'j4sgg': 4880,
  'j4gr': 4920,
  'j4ccb': 4960,
  'j4mca': 4970,
  'j4cgr': 4990,
  'j4fscgr': 5010,
  'j5sbl': 5030,
  'j5sivo': 5040,
  'j5sgg': 5050,
  'j5gr': 5090,
  'j5cgr': 5140,
  'j5fscgr': 5180,
  'j6asbl': 5200,
  'j6asivo': 5210,
  'j6agr': 5230,
  'j6bsbl': 5240,
  'j6bsivo': 5250,
  'j6bgg': 5270,
  'j6bgr': 5290,
  'j6bccb': 5320,
  'j6bmca': 5330,
  'j6bcgr': 5350,
  'j6bfscgr': 5390,
  'j6divo': 5410,
  'j6dgr': 5420,
  'j6dcgr': 5450,
  'j7asbl': 5460,
  'j7asivo': 5470,
  'j7agg': 5500,
  'j7agr': 5510,
  'j7bsbl': 5530,
  'j7bsivo': 5540,
  'j7bsgg': 5550,
  'j7bgr': 5590,
  'j7bccb': 5630,
  'j7bmca': 5640,
  'j7bcgr': 5660,
  'j7bfscgr': 5700,
  'j7csbl': 5720,
  'j7csivo': 5730,
  'j7csgg': 5740,
  'j7cgr': 5780,
  'j7cccb': 5810,
  'j7cmca': 5820,
  'j7ccgr': 5840,
  'j7divo': 5860,
  'j7dgr': 5870,
  'j7dccb': 5880,
  'j7dmca': 5890,
  'j7dcgr': 5910,
  'j7dfscgr': 5930,
  'j8sbl': 5960,
  'j8gr': 5970,
  'j9sbl': 5980,
  'j9gr': 5990,
  'j10sbl': 6000,
  'j10gr': 6020,
  'j11sbl': 6030,
  'j11gr': 6040,
  'j12asbl': 6050,
  'j12asivo': 6060,
  'j12agg': 6080,
  'j12agr': 6090,
  'j12accb': 6100,
  'j12amca': 6110,
  'j12acgr': 6120,
  'j12bsbl': 6130,
  'j12bsivo': 6140,
  'j12bsgg': 6150,
  'j12bgr': 6190,
  'j12bccb': 6230,
  'j12bmca': 6240,
  'j12bcgr': 6260,
  'j12bfscgr': 6280,
  'j12csbl': 6290,
  'j12csivo': 6300,
  'j12csgg': 6310,
  'j12cgr': 6350,
  'j12cccb': 6380,
  'j12cmca': 6390,
  'j12ccgr': 6410,
  'j12cfssmcc': 6420,
  'j12cfscgr': 6430,
  'j12dsbl': 6440,
  'j12dsivo': 6450,
  'j12dgr': 6480,
  'j12dccb': 6510,
  'j12dmca': 6520,
  'j12dcgr': 6540,
  'j12dfscgr': 6560,
  'j13asbl': 6580,
  'j13asivo': 6590,
  'j13agr': 6610,
  'j13bsbl': 6620,
  'j13bsivo': 6630,
  'j13bsgg': 6640,
  'j13bgr': 6680,
  'j13bcgr': 6710,
  'j13civo': 6740,
  'j13cgr': 6750,
  'j13cccb': 6760,
  'j13cmca': 6770,
  'j14sbl': 6810,
  'j14ivo': 6820,
  'j14gr': 6830,
  'j15asbl': 6860,
  'j15asivo': 6870,
  'j15agr': 6890,
  'j15acgr': 6900,
  'j15bsbl': 6910,
  'j15bsivo': 6920,
  'j15bsgg': 6930,
  'j15bgr': 6970,
  'j15bccb': 7010,
  'j15bmca': 7020,
  'j15bcgr': 7030,
  'j15bfscgr': 7040,
  'j15divo': 7050,
  'j15dgr': 7060,
  'j15dccb': 7070,
  'j15dmca': 7080,
  'j15dcgr': 7100,
  'j15dfscgr': 7110,
  'j16bl': 7120,
  'j16ivo': 7130,
  'j16gr': 7140,
  'j17gr': 7150,
  'j18gr': 7160,
  'j19sbl': 7170,
  'j19ivo': 7180,
  'j19gr': 7190,
  'j20sbl': 7220,
  'j20ivo': 7230,
  'j20gr': 7240,
  'j21sbl': 7250,
  'j21ivo': 7260,
  'j21gr': 7270,
  'j22asbl': 7280,
  'j22agr': 7290,
  'j22bsbl': 7300,
  'j22bgr': 7320,
  'j23asbl': 7330,
  'j23asivo': 7340,
  'j23agr': 7370,
  'j23bsbl': 7380,
  'j23bsivo': 7390,
  'j23bsgg': 7400,
  'j23bgr': 7440,
  'j23bcgr': 7480,
  'j23cgr': 7520,
  'j23ccgr': 7530,
  'j23divo': 7540,
  'j23dgr': 7550,
  'j23gfscgr': 7570,
  'j26sbl': 7600,
  'j26sivo': 7610,
  'j26sgg': 7620,
  'j26gr': 7660,
  'j26cgr': 7690,
  'j26fscgr': 7700,
  'j30sbl': 7720,
  'j30gr': 7740,
  'j33sbl': 7750,
  'j33gr': 7770,
  'j36gr': 7790,
  'j38asbl': 7800,
  'j38asivo': 7810,
  'j38agr': 7840,
  'j38acgr': 7870,
  'j38bsbl': 7890,
  'j38bsivo': 7900,
  'j38bsgg': 7910,
  'j38bgr': 7950,
  'j38bcgr': 7980,
  'j42sbl': 8000,
  'j42gr': 8020,
  'j43setsbl': 8040,
  'j43setsivo': 8050,
  'j43setgr': 8060,
  'j44gr': 8070,
  'j46sbl': 8080,
  'j46sivo': 8090,
  'j46smcc': 8100,
  'j46gr': 8130,
  'j46ccb': 8150,
  'j46mca': 8160,
  'j46cgr': 8180,
  'j46aivo': 8190,
  'j46agr': 8200,
  'j47ivo': 8210,
  'j47gr': 8220,
  'j48gr': 8250,
  'j49sbl': 8260,
  'j49sivo': 8270,
  'j49sgg': 8280,
  'j49gr': 8320,
  'j49cgr': 8380,
  'j49fssmcc': 8400,
  'j49fscgr': 8410,
  'j49dsbl': 8460,
  'j49dsivo': 8470,
  'j49dgr': 8490,
  'j49dcgr': 8500,
  'j50agr': 8550,
  'j50bsbl': 8560,
  'j50bsivo': 8570,
  'j50bsgg': 8580,
  'j50bgr': 8610,
  'j50cgr': 8620,
  'j53asbl': 8650,
  'j53asivo': 8660,
  'j53asgg': 8670,
  'j53agr': 8700,
  'j57bgg': 8750,
  'j57bgr': 8760,
  'j59asbl': 8780,
  'j59asivo': 8790,
  'j59asgg': 8800,
  'j59agr': 8840,
  'j59acgr': 8870,
  'j59csbl': 8890,
  'j59csivo': 8900,
  'j59csgg': 8910,
  'j59cgr': 8950,
  'j59ccgr': 9000,
  'j59divo': 9010,
  'j59dgr': 9020,
  'j66aivo': 9070,
  'j66agr': 9090,
  'j66bsbl': 9100,
  'j66bsivo': 9110,
  'j66bgr': 9130,
  'j71sbl': 9230,
  'j71sivo': 9240,
  'j71sgg': 9250,
  'j71gr': 9290,
  'j71cgr': 9330,
  'j100lsbl': 9570,
  'j100lsivo': 9580,
  'j100lgr': 9610,
  'j100lcgr': 9640,
  'j100rsbl': 9650,
  'j100rsivo': 9660,
  'j100rgr': 9690,
  'j100rcgr': 9720,
  'j102asbl': 9730,
  'j102asivo': 9740,
  'j102agr': 9760,
  'j102bsbl': 9770,
  'j102bsivo': 9780,
  'j102bgr': 9800,
  'j103sbl': 9810,
  'j103sivo': 9820,
  'j103sgg': 9830,
  'j103smcc': 9840,
  'j103gr': 9880,
  'j103as2bl': 9900,
  'j104sbl': 9920,
  'j104ivo': 9940,
  'j104gr': 9950,
  'j105livo': 9960,
  'j105lgr': 9970,
  'j105lcgr': 10000,
  'j105rivo': 10020,
  'j105rgr': 10030,
  'j105rcgr': 10060,
  'j106ivo': 10290,
  'j106gr': 10300,
  'j107ivo': 10320,
  'j107gr': 10330,
  'j107ccb': 10340,
  'j107mca': 10350,
  'j107fscgr': 10360,
  'j108sbl': 10370,
  'j108sivo': 10380,
  'j108gr': 10410,
  'j108cgr': 10430,
  'j108fscgr': 10440,
  'j109bsivo': 10490,
  'j109bgr': 10510,
  'j110sbl': 10520,
  'j110peivo': 10540,
  'j110asbl': 10550,
  'j110asivo': 10560,
  'j110agr': 10590,
  'j110acgr': 10600,
  'j110dbl': 10650,
  'j112asbl': 10700,
  'j112asivo': 10710,
  'j112asgg': 10720,
  'j112asmcc': 10730,
  'j112agr': 10770,
  'j112acgr': 10800,
  'j112bsbl': 10810,
  'j112bsivo': 10820,
  'j112bgr': 10840,
  'j113sbl': 10850,
  'j113sivo': 10860,
  'j113gr': 10890,
  'j113asbl': 10930,
  'j113asivo': 10940,
  'j113agr': 10970,
  'j113acgr': 10980,
  'j113bivo': 10990,
  'j113bgr': 11000,
  'j113bccb': 11010,
  'j113bmca': 11020,
  'j113bcgr': 11040,
  'j114sbl': 11050,
  'j114sivo': 11060,
  'j114sgg': 11070,
  'j114gr': 11110,
  'j115sbl': 11130,
  'j115sivo': 11140,
  'j115gr': 11160,
  'j116setsbl': 11170,
  'j116setgr': 11180,
  'j117lsbl': 11190,
  'j117lsivo': 11200,
  'j117lgr': 11220,
  'j117rsbl': 11230,
  'j117rsivo': 11240,
  'j117rgr': 11260,
  'j118asbl': 11270,
  'j118asivo': 11280,
  'j118asgg': 11290,
  'j118agr': 11330,
  'j118acgr': 11360,
  'j118afssmcc': 11380,
  'j118afscgr': 11390,
  'j118bsbl': 11400,
  'j118bsivo': 11410,
  'j118bsgg': 11420,
  'j118bgr': 11460,
  'j118bccb': 11500,
  'j118bmca': 11510,
  'j118bcgr': 11530,
  'j118bfssmcc': 11550,
  'j118bfscgr': 11560,
  'j119asbl': 11580,
  'j119asivo': 11590,
  'j119asgg': 11600,
  'j119agr': 11640,
  'j119accb': 11660,
  'j119amca': 11670,
  'j119acgr': 11690,
  'j119bsbl': 11700,
  'j119bsivo': 11710,
  'j119bgr': 11740,
  'j119bcgr': 11780,
  'j119fssmcc': 11790,
  'j119fscgr': 11800,
  'j120asivo': 11810,
  'j120agr': 11830,
  'j120acgr': 11850,
  'j120afssmcc': 11860,
  'j120afscgr': 11870,
  'j120bsbl': 11880,
  'j120bsivo': 11890,
  'j120bsgg': 11900,
  'j120bgr': 11940,
  'j120bcgr': 11980,
  'j120bfssmcc': 12000,
  'j120bfscgr': 12010,
  'j121asbl': 12020,
  'j121asivo': 12030,
  'j121agr': 12050,
  'j121accb': 12060,
  'j121amca': 12070,
  'j121acgr': 12080,
  'j121bsbl': 12090,
  'j121bsivo': 12100,
  'j121bgr': 12120,
  'j121bccb': 12150,
  'j121bmca': 12160,
  'j122gr': 12170,
  'j123sbl': 12190,
  'j123sivo': 12200,
  'j123gr': 12230,
  'j123cgr': 12240,
  'j124asbl': 12250,
  'j124asivo': 12260,
  'j124agr': 12280,
  'j124bsbl': 12290,
  'j124bsivo': 12300,
  'j124bgr': 12320,
  'j125asbl': 12330,
  'j125asivo': 12340,
  'j125agr': 12370,
  'j125accb': 12390,
  'j125amca': 12400,
  'j125acgr': 12420,
  'j125afssmcc': 12430,
  'j125afscgr': 12440,
  'j125bsbl': 12450,
  'j125bsivo': 12460,
  'j125bgr': 12490,
  'j125bccb': 12520,
  'j125bmca': 12530,
  'j125bcgr': 12550,
  'j125bfssmcc': 12560,
  'j125bfscgr': 12570,
  'j129sbl': 12620,
  'j129sivo': 12630,
  'j130sbl': 12650,
  'j130sivo': 12660,
  'j131sbl': 12680,
  'j131sivo': 12690,
  'j138ivo': 12840,
  'j138gr': 12850,
  'j140gr': 12880,
  'j140pemn': 12900,
  'j141setsivo': 12910,
  'j143sivo': 12920,
  'j143gg': 12940,
  'j143gr': 12950,
  'j144sbl': 12970,
  'j144sivo': 12980,
  'j144gr': 13000,
  'j144cgr': 13010,
  'j145sbl': 13020,
  'j145ivo': 13030,
  'j145gr': 13040,
  'j145cgr': 13050,
  'j146sivo': 13060,
  'j146gr': 13080,
  'j147sbl': 13090,
  'j147sivo': 13100,
  'j147sgg': 13110,
  'j147gr': 13140,
  'j147cgr': 13170,
  'j147asivo': 13180,
  'j147agr': 13200,
  'j147bpabl': 13210,
  'j150sbl': 13260,
  'j150sivo': 13270,
  'j150gr': 13300,
  'j150ccb': 13330,
  'j150mca': 13340,
  'j150cgr': 13360,
  'j150bsivo': 13380,
  'j150bgr': 13400,
  'j150bcgr': 13410,
  'j157asbl': 13500,
  'j157asgg': 13510,
  'j157agr': 13530,
  'j166sbl': 13590,
  'j166sivo': 13600,
  'j174abl': 13820,
  'j174acgr': 13830,
  'j174bbl': 13850,
  'j174bcgr': 13870,
  'j174cbl': 13890,
  'j174ccgr': 13900,
  'j174dbl': 13910,
  'j174dcgr': 13920,
  'j176sets2mcc': 13960,
  'jb4ivo': 13970,
  'jb4gr': 13980,
  'jb4ccb': 13990,
  'jb4mca': 14000,
  'jb5ivo': 14030,
  'jb5gr': 14040,
  'jb5ccb': 14050,
  'jb5mca': 14060,
  'jb6bivo': 14090,
  'jb6bgr': 14100,
  'jb6bccb': 14110,
  'jb6bmca': 14120,
  'jb6divo': 14150,
  'jb6dgr': 14160,
  'jb6dccb': 14170,
  'jb6dmca': 14180,
  'jb7bivo': 14200,
  'jb7bgr': 14210,
  'jb7dgr': 14280,
  'jb7dccb': 14290,
  'jb7dmca': 14300,
  'jb12bivo': 14320,
  'jb12bgr': 14330,
  'jb12bccb': 14340,
  'jb12bmca': 14350,
  'jb12dgr': 14380,
  'jb13bivo': 14400,
  'jb13bgr': 14410,
  'jb15bivo': 14430,
  'jb15bgr': 14440,
  'jb15divo': 14460,
  'jb15dgr': 14470,
  'jb23bivo': 14490,
  'jb23bgr': 14510,
  'jb26ivo': 14530,
  'jb26gr': 14550,
  'jb38aivo': 14580,
  'jb38agr': 14590,
  'jb46ivo': 14610,
  'jb46gr': 14620,
  'jb49ivo': 14660,
  'jb49gr': 14680,
  'jb57aivo': 14710,
  'jb57agr': 14720,
  'jb59civo': 14730,
  'jb59cgr': 14740,
  'jb71ivo': 14770,
  'jb71gr': 14780,
  'jb100livo': 14820,
  'jb100lgr': 14830,
  'jb100rivo': 14860,
  'jb100rgr': 14870,
  'jb105livo': 14890,
  'jb105lgr': 14900,
  'jb105rivo': 14920,
  'jb105rgr': 14930,
  'jb106gr': 14950,
  'jb110agr': 14990,
  'jb110dbl': 15010,
  'jb112agr': 15020,
  'jb113bgr': 15040,
  'jb118bivo': 15060,
  'jb118bgr': 15070,
  'jb120bivo': 15090,
  'jb120bgr': 15100,
  'jb147ivo': 15130,
  'jb147gr': 15140,
  'jb170ivo': 15260,
  'jb170gr': 15270,
  'jl49sbl1': 15310,
  'jl110sbl': 15350,
  'jl113bivo': 15370,
  'jl113bgr': 15380,
  'je101setivo': 15620,
  'je101setgr': 15630,
  'jg11asbl': 15820,
  'jg11asivo': 15830,
  'jg11agr': 15860,
  'jg11acgr': 15870,
  'jpe4ivo': 15940,
  'jpe4wgr': 15950,
  'jpe5ivo': 15960,
  'jpe5gr': 15970,
  'jpe5wgr': 15980,
  'jpe7ivo': 15990,
  'jpe7gr': 16000,
  'jpe7wgr': 16010,
  'jpe12ivo': 16020,
  'jpe12wgr': 16030,
  'jg1ivo': 16190,
  'jg1gr': 16200,
  'jg2ivo': 16210,
  'jg2gr': 16220,
  'jg3ivo': 16230,
  'jg4ivo': 16250,
  'jg4gr': 16260,
  'jg5ivo': 16270,
  'jg5gr': 16280,
  'jg6ivo': 16290,
  'jg7ivo': 16310,
  'jg7gr': 16320,
  'jg8ivo': 16330,
  'jg8gr': 16340,
  'jg9ivo': 16350,
  'jg9gr': 16360,
  'hj1s': 16390,
  'hj1ni': 16420,
  'hj1s4': 16470,
  'hj2s': 16480,
  'hj2ni': 16510,
  'hj2s2': 16540,
  'hj3s': 16550,
  'hj3ni': 16580,
  'hj4s': 16610,
  'hj4ni': 16640,
  'hj5s': 16680,
  'hj5ni': 16700,
  'hj6s': 16730,
  'hj6ni': 16760,
  'hj6s4': 16800,
  'hj7s': 16810,
  'hj7ni': 16840,
  'hj7s2': 16870,
  'hj8ｾﾂﾄs': 16880,
  'hj8ｾﾂﾄni': 16910,
  'hj9s': 16920,
  'hj9ni': 16940,
  'hj10ｾﾂﾄs': 16950,
  'hj10ｾﾂﾄni': 16980,
  'hj11s': 17000,
  'hj11ni': 17030,
  'hj12s': 17060,
  'hj12ni': 17080,
  'hj15ｾﾂﾄ': 17100,
  'hj15ｾﾂﾄni': 17110,
  'hj16ｾﾂﾄ': 17120,
  'hj16ｾﾂﾄni': 17130,
  'hj19': 17140,
  'hj19ni': 17150,
  'hpej1': 17170,
  'hpej1ni': 17180,
  'hpej1w': 17200,
  'hpej1wni': 17210,
  'hpej2': 17220,
  'hpej2ni': 17230,
  'hpej2w': 17240,
  'hpej2wni': 17250,
  'hpej4': 17270,
  'hpej4ni': 17280,
  'hpej4w': 17290,
  'hpej4wni': 17300,
  'h1': 17420,
  'h2': 17590,
  'h3': 17650,
  'h4': 17700,
  'h5': 17770,
  'h6': 17830,
  'h7': 17890,
  'h8': 17980,
  'h9': 18020,
  'h10': 18060,
  'h11': 18100,
  'h12': 18140,
  'h13': 18190,
  'h19': 18280,
  'sj1': 18300,
  'sj1ni': 18310,
  'sj2': 18320,
  'sj2ni': 18330,
  'sj3': 18340,
  'sj3ni': 18350,
  'sj4': 18360,
  'sj4ni': 18370,
  'sj5': 18380,
  'sj5ni': 18390,
  'sj6': 18400,
  'sj6ni': 18410,
  'sj7': 18420,
  'sj7ni': 18430,
  'sj8': 18440,
  'sj8a': 18450,
  'sj8ani': 18460,
  'sj9': 18470,
  'sj10': 18480,
  'sj10a': 18490,
  'sj10ani': 18500,
  'sj11a': 18510,
  'sj11ani': 18520,
  'bej1a': 18620,
  'sej1b': 18630,
  'sej1bni': 18640,
  'sej2b': 18650,
  'sej2bni': 18660,
  'sej4b': 18670,
  'sej4bni': 18680,
  'sej6a': 18690,
  'sej6ani': 18700,
  'sej11a': 18710,
  'sej11ani': 18720,
  'lj1as': 18730,
  'lj1ani': 18750,
  'lj2as': 18760,
  'lj2ani': 18780,
  'lj3a': 18790,
  'lj3ani': 18800,
  'lj4a': 18810,
  'lj4ani': 18820,
  'lj5a': 18830,
  'lj5ani': 18840,
  'lj6as': 18850,
  'lj6ani': 18870,
  'lj7as': 18880,
  'lj7ani': 18900,
  'lj10a': 18910,
  'lj10ani': 18920,
  'lj11a': 18930,
  'lj11ani': 18940,
  'lj12a': 18950,
  'lj12ani': 18960,
  'lej1as': 18990,
  'lej1ani': 19010,
  'lej1bs': 19020,
  'lej1bni': 19040,
  'lej2bs': 19050,
  'lej2bni': 19070,
  'lej3b': 19080,
  'lej3bni': 19090,
  'lej4b': 19100,
  'lej4bni': 19110,
  'lej5b': 19120,
  'lej5bni': 19130,
  'lej6a': 19140,
  'lej6ani': 19150,
  'lej7as': 19160,
  'lej7ani': 19180,
  'lej7bs': 19190,
  'lej7bni': 19210,
  'lej12b': 19220,
  'lej12bni': 19230,
  'hej1': 19240,
  'hej2': 19260,
  'jr1blｽﾃﾝ': 19280,
  'jr2blｽﾃﾝ': 19290,
  'jr3blｽﾃﾝ': 19300,
  'jr4blｽﾃﾝ': 19310,
  'jr5blｽﾃﾝ': 19320,
  'jg12setsbl': 19380,
  'jg12setsivo': 19390,
  'jg12setgr': 19420,
  'jg12setbivo': 19480,
  'jg12setbcgr': 19500,
  'jg12fssetcgr': 19510,
  'jg12fssetbccb': 19540,
  'jg12fssetbmca': 19550,
  'jg12fssetbcgr': 19570,
  'jbg12fssetgr': 20260,
  'jbg12fssetbgr': 20280,
  'ekit1': 20450,
  'ｵｻｴｲﾀ': 20460,
  'ef1000h': 20490,
  'ｼｼﾞｲﾀb': 20510,
  'ｼｼﾞｲﾀc': 20530,
  'ef1002g': 20550,
  'ef1002h': 20570,
  'ef1006s': 20580,
  'ef1008as': 20620,
  'ef1009as': 20670,
  'ef1010as': 20700,
  'ef1010bs': 20720,
  'ef1012sus': 20780,
  'ef1012asus': 20790,
  'ｶｷﾞｶﾅｸﾞas': 20820,
  'ｶｷﾞｶﾅｸﾞbs': 20840,
  'ｲﾀｱﾅｶﾅｸﾞs': 20860,
  'ef1026wgr': 20940,
  'ｱｼﾞﾔｽﾀsbl': 20970,
  'ｱｼﾞﾔｽﾀsivo': 20980,
  'ｱｼﾞﾔｽﾀgr': 21010,
  'ｺﾞﾑｲﾝﾅs': 21090,
  'ｺﾞﾑｱｳﾀaｾﾂﾄs': 21110,
  'ｺﾞﾑｱｳﾀbｾﾂﾄs': 21140,
  'ﾊﾄﾞｷﾔﾂﾌﾟsbl': 21170,
  'ﾊﾄﾞｷﾔﾂﾌﾟsivo': 21180,
  'ﾊﾄﾞｷﾔﾂﾌﾟgr': 21210,
  'ﾊﾄﾞｷﾔﾂﾌﾟｺﾞﾑﾂｷsbl': 21230,
  'ﾊﾄﾞｷﾔﾂﾌﾟｺﾞﾑﾂｷsivo': 21240,
  'ﾊﾄﾞｷﾔﾂﾌﾟｺﾞﾑﾂｷgr': 21270,
  'ﾊﾟｲﾌﾟｽﾀﾝﾄﾞss': 21330,
  'ｲﾝｻﾄﾅﾂﾄm16': 21370,
  'ef1213e': 21450,
  'ef1217asset': 21500,
  'ef1217a': 21520,
  'ef1217bset': 21530,
  'ef1217b': 21540,
  'ﾊﾒｺﾐｶﾅｸﾞas': 21590,
  'ef1254s': 21750,
  'ef1265n': 21900,
  'ef1269sus': 21920,
  'ef1271s2set': 21950,
  'ﾊﾟｲﾌﾟﾛﾂｸｶﾅｸﾞas': 21970,
  'ef3000as': 22540,
  'ef4004s': 22700,
  'ef4018s': 22860,
  'ef4018ni': 22880,
  'ﾌﾂｸｿｸﾒﾝ20ｺ': 23130,
  'ﾌﾂｸﾔﾈ20ｺ': 23140,
  'ｷﾔﾂﾁｿｸﾒﾝ20ｺbl': 23150,
  'ｷﾔﾂﾁｿｸﾒﾝ20ｺivo': 23160,
  'ｷﾔﾂﾁﾔﾈ20ｺbl': 23170,
  'ｷﾔﾂﾁﾔﾈ20ｺivo': 23180,
  'ｵｻｴｲﾀ32': 23610,
  'ｼｼﾞｲﾀ32c': 23620,
  'eb1006': 23630,
  'ｶﾀｻﾄﾞﾙ32b': 23640,
  'eb1026wgr': 23660,
  'eb1210d': 23670,
  'eb4018': 23680,
  'eb3014hcssl': 23720,
  'eb3024hcssl': 23730,
  'eb3025hcssl': 23740,
  'eb3026hcssl': 23750,
  'eb3034hcssl': 23760,
  'el1000d': 23770,
  'el1008a': 23780,
  'el1206sas': 23800,
  'el2265dni': 23860,
  'el4018': 23870,
  'el4018ni': 23880,
  'm625bﾎﾞﾙﾄﾅﾂﾄ': 26370,
  'm630bﾎﾞﾙﾄﾅﾂﾄ': 26440,
  'm820': 26600,
  'm840': 26710,
  'ygr50st': 26890,
  'ygr50sst': 26900,
  'ygr50e': 26970,
  'ygr50se': 26980,
  'ygr65': 27020,
  'ygr65s': 27030,
  'ygr65e': 27080,
  'ygr65se': 27090,
  'ygr75': 27120,
  'ygr75s': 27130,
  'ygr75e': 27180,
  'ygr75se': 27190,
  'ygr100st': 27200,
  'ygr100sst': 27210,
  'ygr100e': 27280,
  'ygr100se': 27290,
  'ynr50nsus': 27660,
  'ynr50snsus': 27670,
  'ynr65nsus': 27680,
  'ynr65snsus': 27690,
  'ynr75nsus': 27700,
  'ynr75snsus': 27710,
  'ynr100nsus': 27720,
  'ynr100snsus': 27730,
  'jc40sast': 27820,
  'jc75sast': 27830,
  'jc75st': 27850,
  'jc75sst': 27860,
  'cjr65': 28640,
  'cjr65s': 28650,
  'cjr75': 28660,
  'cjr75s': 28670,
  'yj130': 28680,
  'yj130s': 28690,
  'yj150': 28760,
  'yj150s': 28770,
  'yj200': 28850,
  'yj200s': 28860,
  'yk130': 28960,
  'yk150': 29000,
  'yk200': 29050,
  'yjc100': 29340,
  'yjc100s': 29350,
  'ykc100': 29380,
  'ek9': 30040,
  'ek9a': 30050,
  'ﾊﾝﾄﾞｶﾂﾀｶｴﾊﾞ': 30070,
  'ek6': 30130,
  'ek6aｶｴﾊﾞ': 30140,
  'ek7': 30150,
  'ek7a': 30160,
  'ek8': 30170,
  'ek10s': 30180,
  'ek11s': 30200,
  'ek20s': 30210,
  'ek41s': 30240,
  'ey30': 30270,
  'ey50': 30280,
  'ey100': 30290,
  'yas1011': 30330,
  'esa40ivo': 30340,
  'esa60ivo': 30350,
  'es70ivo': 30370,
  'fe3490ｾﾂﾄgr': 30390,
  'fe34120ｾﾂﾄgr': 30410,
  'fe34150ｾﾂﾄgr': 30430,
  'fe34180ｾﾂﾄgr': 30450,
  'yfh120gg': 30540,
  'yfh150gg': 30550,
  'yfr92ｾﾂﾄ': 30560,
  'yfr93ｾﾂﾄ': 30580,
  'yfr182ｾﾂﾄ': 30600,
  'yfr183ｾﾂﾄ': 30620,
  'sb300l2ﾏｲbr': 30650,
  'sb300l3ﾏｲbr': 30660,
  'yfw19gg': 30670,
  'yfw19sﾀｲﾌﾟgg': 30680,
  'yfw25gg': 30690,
  'pg27br6': 30710,
  'tr6070bl': 30720,
  'tr6070cbl': 30730,
  'wcged2': 31450,
  'wcget': 31460,
  'wcghd2': 31470,
  'wcght': 31480,
  'wcg1s2': 31490,
  'wcg2s2': 31500,
  'pka12400h33': 45960,
  'pka13000h33': 45970,
  'pka32400h50': 46000,
  'pka33000h50': 46010,
  'pkb32400h50': 46040,
  'pkb33000h50': 46050,
  'pkc12000h16': 46080,
  'pkc13000h16': 46100,
  'pca12400h33': 46140,
  'pca13000h33': 46150,
  'pca32400h50': 46180,
  'pca33000h50': 46190,
  'pcb32400h50': 46300,
  'pcb33000h50': 46310,
  'pcc12000h16': 46390,
  'pcc13000h16': 46410,
  'ef2041ccrs': 47290,
  'ef2041dcrs': 47300,
  'ef2041dwcrs': 47310,
  'ef2041ecrs': 47320,
  'ef2041fcrs': 47330,
  'el2040c': 47490,
  'el2040dw': 47500,
  'pwa12400h43': 47590,
  'pwa13000h43': 47600,
  'pwa32400h57': 47630,
  'pwa33000h57': 47640,
  'pwa52400h86': 47670,
  'pwa53000h86': 47680,
  'pwb12400h43': 47710,
  'pwb13000h43': 47720,
  'pwb32400h57': 47750,
  'pwb33000h57': 47760,
  'pwb52400h86': 47790,
  'pwb53000h86': 47800,
  'pwc12400h19': 47830,
  'pwc13000h19': 47840,
  'ef2065c': 48820,
  'ef2065d': 48830,
  'ef2065dw': 48840,
  'ef2065e': 48850,
  'ef2065g': 48860,
  'ef2065ha': 48870,
  'ef2065hb': 48880,
  'ef2067cb': 48890,
  'ef2066c': 48900,
  'ef2066d': 48910,
  'ef2066dw': 48930,
  'ef2066e': 48940,
  'ef2066g': 48950,
  'ef2068': 48960,
  'el2066c': 49150,
  'el2066dw': 49160,
  'el2066g': 49170,
  'el2068': 49180,
  'n450': 50130,
  'n450l': 50140,
  'n600gr': 50150,
  'n750': 50160,
  'n450lwivo': 50180,
  'n450w': 50190,
  'n450ｵﾘﾀﾀﾐｶﾅｸﾞｾﾂﾄ': 50200,
  'n450ﾄﾂﾃ': 50210,
  'n450lﾄﾂﾃ': 50250,
  'n450lﾄﾂﾃｾﾂﾄ': 50260,
  'n600ﾄﾂﾃ': 50300,
  'n600ﾄﾂﾃｾﾂﾄ': 50310,
  'n750ﾄﾂﾃ': 50330,
  'n750ﾄﾂﾃｾﾂﾄ': 50340,
  'ｵﾘﾀﾀﾐｶﾅｸﾞ': 50580,
  'ｵﾘﾀﾀﾐｶﾅｸﾞｶﾊﾞgr': 50590,
  'n32ll': 50710,
  'n32lr': 50720,
  'n32sl': 50730,
  'n32sr': 50740,
  'gn400stdgr': 51080,
  'gn400stg': 51090,
  'gn400stbl': 51100,
  'gn400stwr': 51110,
  'gn400stdb': 51120,
  'gn900stdgr': 51240,
  'gn900stg': 51250,
  'gn901dgr': 51340,
  'gn901g': 51350,
  'gn400rtstdgr': 51420,
  'gn400rtstg': 51430,
  'gn900rtstdgr': 51550,
  'gn900rtstg': 51560,
  'yj75ntst': 51950,
  'yj75ntsus': 51970,
  'yj75rtst': 51980,
  'yj100nt': 52020,
  'ek22': 52050,
  'sc9060axor': 52060,
  'sc9060axbl': 52070,
  'sc9060axskh': 52080,
  'sc9060axnv': 52090,
  'sc9060axog': 52100,
  'sc9060axftor': 52110,
  'sc9060axftbl': 52120,
  'sc9060axftskh': 52130,
  'sc9060axftnv': 52140,
  'sc9060axftog': 52150,
  'sc9060axdhaor': 52170,
  'sc9060axdhabl': 52180,
  'sc9060axdhaskh': 52190,
  'sc9060axdhanv': 52200,
  'sc9060axdhaog': 52210,
  'sc9060axdhaftor': 52220,
  'sc9060axdhaftbl': 52230,
  'sc9060axdhaftskh': 52240,
  'sc9060axdhaftnv': 52250,
  'sc9060axdhaftog': 52260,
  'sc9060caor': 52270,
  'sc9060cabl': 52280,
  'sc9060caskh': 52290,
  'sc9060canv': 52300,
  'sc9060caog': 52310,
  'sc9060caftor': 52320,
  'sc9060caftbl': 52330,
  'sc9060caftskh': 52340,
  'sc9060caftnv': 52350,
  'sc9060caftog': 52360,
  'sc9060cadhaor': 52370,
  'sc9060cadhabl': 52380,
  'sc9060cadhaskh': 52390,
  'sc9060cadhanv': 52400,
  'sc9060cadhaog': 52410,
  'sc9060cadhaftor': 52420,
  'sc9060cadhaftbl': 52430,
  'sc9060cadhaftskh': 52440,
  'sc9060cadhaftnv': 52450,
  'sc9060cadhaftog': 52460,
  'axn450': 52470,
  'axn450l': 52480,
  'axn600': 52490,
  'ef1220150aset': 52500,
  'ef1220130aset': 52510,
  'scpblpsus2ｺｾﾂﾄ': 52520,
  'scph600ｾﾂﾄ': 52540,
  'axmploaia3pcasgr': 52610,
  'axmpoaia4pcasgr': 52630,
  'axp800cbｱﾀﾂﾁﾒﾝﾄｾﾂﾄ': 52650,
  'axp900cbｱﾀﾂﾁﾒﾝﾄｾﾂﾄ': 52660,
  'axp40ppporﾎﾞﾙﾄﾅﾂﾄ30ｺｾﾂﾄ': 52670,
  'axp90ppporﾅﾂﾄ8ｺｾﾂﾄ': 52680,
  'axpmb2ppbl4ｺｾﾂﾄ': 52690,
  'ef1029l/rblｶｸ2ｺｾﾂﾄ': 52700,
  'pt1stb10': 52980,
  'pt1sty10': 52990,
  'pt2astb10': 53190,
  'pt2asty10': 53200,
  'pt2bstb10': 53350,
  'pt2bstc11': 53360,
  'pt2bsty10': 53370,
  'pt3bstb10': 53580,
  'pt3bsty10': 53590,
  'pt5stb10': 53950,
  'pt5stc11': 53960,
  'pt5stgr6': 53970,
  'pt5sty10': 53980,
  'pt9stb10': 55020,
  'pt9stc11': 55030,
  'pt9stgr6': 55040,
  'pt9sty10': 55050,
  'pt14stb10': 56980,
  'pt14stc11': 56990,
  'pt14stgr6': 57000,
  'pt14sty10': 57010,
  'pt18dstb10': 58010,
  'pt21stb10': 58540,
  'pt21stc11': 58550,
  'pt21stgr6': 58560,
  'pt21sty10': 58570,
  'pt24stb10': 59450,
  'pt28stb10': 60060,
  'pt28stc11': 60070,
  'pt28stgr6': 60080,
  'pt28sty10': 60090,
  'pt28cstb10': 60420,
  'pt36cstb10': 61360,
  'pt42cstb10': 62450,
  'pt75stb10': 63380,
  'pt110stb10': 63580,
  'pt5lstb10': 77600,
  'pt5lstc11': 77610,
  'pt5lstgr6': 77620,
  'pt5lsty10': 77630,
  'pt9lstb10': 77760,
  'pt9lstc11': 77770,
  'pt9lstgr6': 77780,
  'pt9lsty10': 77790,
  'pt18dlstb10': 78080,
  'pt24lstb10': 78230,
  'pt28lstb10': 78290,
  'pt28lstc11': 78300,
  'pt28lstgr6': 78310,
  'pt28lsty10': 78320,
  'pt42clstb10': 78650,
  'pt75lstb10': 78850,
  'pt9lsetstb10': 80060,
  'pt9lsetsty10': 80070,
  'pt18dlsetstb10': 80190,
  'pt28lsetstb10': 80320,
  'pt28lsetsty10': 80330,
  'pt75lsetstb10': 80580,
  'sy28c11': 87070,
  'sy48c11': 87110,
  'sy48lc11': 87150,
  'ch4': 87690,
  'ch6': 87710,
  'ch6b': 87720,
  'ch7': 87740,
  'ch7b': 87750,
  'ch9': 87770,
  'ch10a': 87790,
  'ch10b': 87800,
  'ch10c': 87810,
  'ef1264s2bl': 88150,
  'l23b': 88160,
  'l25b': 88180,
  'l30b': 88200,
  'l35b': 88220,
  'l45b': 88240,
  'l55b': 88270,
  'l70b': 88290,
  'l23ﾀｲb': 88310,
  'l25ﾀｲb': 88330,
  'l30ﾀｲb': 88460,
  'l35ﾀｲb': 88480,
  'l45ﾀｲb': 88520,
  'l55ﾀｲb': 88590,
  'l70ﾀｲb': 88610,
  'l23/30ﾌﾀb': 88630,
  'l25ﾌﾀb': 88650,
  'l35/45ﾌﾀb': 88710,
  'l55ﾌﾀb': 88770,
  'l70ﾌﾀb': 88790,
  'yl30b': 88890,
  'yl40b': 88910,
  'yl50b': 88930,
  'yl70b': 88950,
  'yl90b': 88970,
  'yl30ﾀｲb': 88990,
  'yl40ﾀｲb': 89010,
  'yl50ﾀｲb': 89030,
  'yl70ﾀｲb': 89050,
  'yl90ﾀｲb': 89110,
  'yl30ﾌﾀb': 89170,
  'yl40ﾌﾀb': 89190,
  'yl50ﾌﾀb': 89210,
  'yl70ﾌﾀb': 89230,
  'yl90ﾌﾀb': 89290,
  'w36b': 89350,
  'w42b': 89360,
  'w48b': 89370,
  'w54b': 89380,
  'bk80b': 89390,
  'bk90b': 89410,
  'bk100b': 89420,
  'bk150b': 89440,
  'bk170b': 89470,
  'bb15b': 89490,
  'bb18b': 89500,
  'bb21b': 89510,
  'bb24b': 89520,
  'bb27b': 89530,
  'bb30b': 89540,
  'bb33b': 89550,
  'bb36b': 89560,
  'bl4cr': 89570,
  'bl8cr': 89580,
  'bl13cr': 89590,
  'bl18cr': 89600,
  'bl30cr': 89610,
  'bl40cr': 89620,
  'bl4ﾌﾀﾂｷcr': 89650,
  'bl8ﾌﾀﾂｷcr': 89660,
  'bl13ﾌﾀﾂｷcr': 89670,
  'bl18ﾌﾀﾂｷcr': 89680,
  'bl30ﾌﾀﾂｷcr': 89690,
  'bl40ﾌﾀﾂｷcr': 89700,
  'bl4ﾀｲcr': 89730,
  'bl8ﾀｲcr': 89740,
  'bl13ﾀｲcr': 89750,
  'bl18ﾀｲcr': 89760,
  'bl30ﾀｲcr': 89770,
  'bl40ﾀｲcr': 89780,
  'bl4ﾌﾀcr': 89870,
  'bl8ﾌﾀcr': 89880,
  'bl13ﾌﾀcr': 89890,
  'bl18ﾌﾀcr': 89900,
  'bl30ﾌﾀcr': 89910,
  'bl40ﾌﾀcr': 89920,
  'lp4': 89950,
  'lp8': 89960,
  'lp13': 89970,
  'lp18': 89980,
  'lp30': 89990,
  'lp40': 90000,
  'yb4b': 90060,
  'yb6b': 90090,
  'yb8b': 90130,
  'yb10b': 90160,
  'yb12b': 90180,
  'yp5b': 90370,
  'yp8b': 90390,
  'yp10b': 90410,
  'yp13b': 90440,
  'yp15b': 90460,
  'yp18b': 90480,
  'yp5ﾀｲb': 90500,
  'yp8ﾀｲb': 90570,
  'yp10ﾀｲb': 90590,
  'yp13ﾀｲb': 90660,
  'yp15ﾀｲb': 90680,
  'yp18ﾀｲb': 90700,
  'yp5ﾌﾀb': 90720,
  'yp8ﾌﾀb': 90750,
  'yp10ﾌﾀb': 90770,
  'yp13ﾌﾀb': 90800,
  'yp15ﾌﾀb': 90820,
  'yp18ﾌﾀb': 90840,
  'kl30b': 91010,
  'kl30lgr': 91020,
  'kl45b': 91030,
  'kl45lgr': 91040,
  'kl60b': 91050,
  'kl60lgr': 91060,
  'kl30ﾀｲb': 91100,
  'kl30ﾀｲlgr': 91110,
  'kl45ﾀｲb': 91120,
  'kl45ﾀｲlgr': 91130,
  'kl60ﾀｲb': 91140,
  'kl60ﾀｲlgr': 91150,
  'kl30ﾌﾀb': 91220,
  'kl30ﾌﾀlgr': 91230,
  'kl45ﾌﾀb': 91240,
  'kl45ﾌﾀlgr': 91250,
  'kl60ﾌﾀb': 91260,
  'kl60ﾌﾀlgr': 91270,
  'kl10bgr': 91320,
  'kl20bbgr': 91330,
  'kl30bbgr': 91340,
  'kl45bbgr': 91350,
  'kl60bbgr': 91360,
  'kl10bﾌﾀbgr': 91440,
  'kl20bﾌﾀbgr': 91450,
  'kl30bﾌﾀlgr': 91460,
  'kl45bﾌﾀlgr': 91470,
  'kl60bﾌﾀlgr': 91480,
  'cp26g': 91610,
  'cp26lgr': 91620,
  'cp30g': 91630,
  'cp30lgr': 91640,
  'wl10b': 91650,
  'wl12b': 91660,
  'wl10ﾀｲb': 91670,
  'wl12ﾀｲb': 91680,
  'wlh10/12ｴﾉﾐ': 91690,
  'fm36': 91700,
  'fm46': 91710,
  'fl18': 91720,
  'fl30': 91730,
  'fl38': 91740,
  'fl18ﾀｲ': 91750,
  'fl30ﾀｲ': 91760,
  'fl38ﾀｲ': 91770,
  'flh18/30': 91780,
  'flh38': 91790,
  'fj40b': 91820,
  'fj50b': 91830,
  'fj70b': 91840,
  'jh50ab': 91860,
  'hd1624ｹｽ': 94030,
  'hd2535ｹｽ': 94040,
  'hd3238ｹｽ': 94050,
  'hd3238ｹｽbl': 94060,
  'he4550ｹｽ': 94070,
  'he5060ｹｽ': 94080,
  'he5060ｹｽb': 94090,
  'he6585ｹｽ': 94100,
  'hf6585ｹｽb': 94110,
  'hg8090ｹｽ': 94120,
  'hg8090ｹｽb': 94130,
  'hj90100ｹｽ': 94140,
  'bhh6585ｹｽ': 94150,
  'bhh6585ｹｽb': 94160,
  'bhh6585ｹｽbl': 94170,
  'bhh8090ｹｽ': 94180,
  'bhh8090ｹｽb': 94190,
  'bhh8090ｹｽbl': 94200,
  'bhk90100ｹｽ': 94210,
  'bhk90100ｹｽb': 94220,
  'bhk90100ｹｽbl': 94230,
  'hr0920ｹｽ': 94400,
  'hr202025ｹｽ': 94410,
  'hr1220ｹｽ': 94420,
  'hr1230ｹｽ': 94430,
  'hr1320lｹｽ': 94440,
  'hr1320llｹｽ': 94460,
  'hr1520ｹｽ': 94470,
  'hr1525ｹｽ': 94480,
  'hr1530ｹｽ': 94490,
  'hr1630ｹｽ': 94500,
  'hr1930ｹｽ': 94510,
  'hr2030ｹｽ': 94520,
  'hr3225ｹｽ': 94530,
  'hr3230bｹｽ': 94540,
  'hr3230mwｹｽ': 94550,
  'hr3540ｹｽ': 94560,
  'hr3540bｹｽ': 94570,
  'hr3540mwｹｽ': 94580,
  't1206ｹｽ': 94620,
  't1306ｹｽ': 94640,
  't1506ｹｽ': 94650,
  't1606ｹｽ': 94660,
  't1200ｹｽ': 94670,
  'm13085ｹｽ': 94680,
  't1608ｹｽ': 94690,
  'm2308sｹｽ': 94700,
  'm1310lｹｽ': 94710,
  'm2310ｹｽ': 94720,
  't12045ｹｽ': 94740,
  't13045ｹｽ': 94750,
  't15045ｹｽ': 94760,
  't16045ｹｽ': 94770,
  'tg2308s6pcs': 94780,
  'hs122020pcs': 94790,
  'hs132020pcs': 94800,
  'hs152020pcs': 94810,
  'hs162020pcs': 94820,
  'hs1320llｹｽ': 94830,
  'hs12201pcs': 94840,
  'hs13201pcs': 94850,
  'hs15201pcs': 94860,
  'hs16201pcs': 94870,
  'hs1320ll1pcs': 94880,
  'ms1206aｹｽ': 95040,
  'ms1306aｹｽ': 95050,
  'ms1506aｹｽ': 95060,
  'ms1606aｹｽ': 95070,
  'ms1206a1pcs': 95090,
  'ms1306a1pcs': 95100,
  'ms1506a1pcs': 95110,
  'ms1606a1pcs': 95120,
  'mm36400612pcs': 95130,
  'mm36400612pcsg': 95140,
  'tm2308sl6pcs': 95150,
  'hr20tu1001pcs': 95160,
  'tt2020': 95740,
  'tt2310': 95750,
  'sf247ivo': 95840,
  'sf267c': 95850,
  'sf267ivo': 95860,
};
